export default __webpack_public_path__ + "static/media/logo.54f25d7a.png";